import './App.css';
import MyImage from './siraju.jpg';
import phoneImage from './phone.svg';
import email from './email.svg';
import {useRef} from 'react';
//implement click handler
function App() {
    
    const homeref=useRef();
    function handlemode(event){
        homeref.current.scrollIntoView({behavior:"smooth"})

    
    }



  return (
    <div className="App">
    <div className="navigation-bar-container">
    <div className="nav-item">Home.</div>
    <div className="nav-item">Details.</div>
    <div className="nav-item" onClick={handlemode}>Darkmode.</div>
    </div>


    <div className="intro-container" ref={homeref}>
    <div className="image-container">
    <img src={MyImage} alt="nothing" className="profile-image"/></div>
    </div>


    <div className="text-container">
    <p className="first-name">MU<span className=
    "green">HAM</span>MED</p><br/><p className="second-name">SIR<span className="green">AJU</span>
    DEEN.</p>
    </div>

    <div className="about-container">
    <div className="about-text-container">ABOUT ME.<br/>
    <span className="text">Iam basically a Computer Science Enthusiast who loves to work
    on exciting new technologies my Primary Focus is on Web Applications and Artificial Intelligence
    I truly believe in web applications and its strength because I concur with the belief that 
    everything is just a glorified web browser and its architecture is the building
    block that a developer cant avoid .I also love building real time applications and Progressive Web Apps.</span></div>
    </div>

    <div className="skill-container">
    <div className="padding">
    <div className="skill-box"><div><span className="green">Rea</span>ct Web <br/>A
    <span className="green">pps</span></div></div>
    </div>
    <div className="padding">
    <div className="skill-box"><div><span className="green">Mach</span>ine<br/>Learn
    <span className="green">ing</span></div></div>
    </div>
    <div className="padding">
    <div className="skill-box"><div><span className="green">Pyth</span>on <br/> Api ,Web Apps <br/>and 
    <span className="green"> ML/AI</span> </div></div>
    </div>
    <div className="padding">
    <div className="skill-box"><div><span className="green"> Ful</span>l Stack Applic<span className="green">
     ations</span></div></div>
    </div>
    </div>


    <div className="contact-container"  >
    <div className="contact-details">
    <div>CONTACT <span className="green"> ME.</span></div>
    <img src={phoneImage} alt="nothing" className="phone-image"/>
    <div className="details">+91<span className="green">7907140006</span></div>
    <img src={email} alt="nothing" className="phone-image"/>
    <div className="details">muhammedsirajudeen29@<span className="green"> gmail.com</span></div>
    </div>
    </div>

    <div className="final-container">
    <div className="detail-container"><div className="final-text">copyright © : muhammedsirajudeen.</div></div>
    </div>

    <div className="float-menu">
    <div className="float-content">
    <div className="float-text">Explore</div>
    <div className="float-text">Navigate</div>
    <div className="float-text" onClick={handlemode}>Home</div>
    </div>
    </div>
    
      
    </div>
  );
}

export default App;
